module.exports = __webpack_public_path__ + "img/20190824114649719.8c0621c9.jpg";